import styled from "styled-components";
import { BLACK, DINGY_GRAY, GRAY, GREEN, LIGHT_GRAY, NEAR_WHITE, ORANGE, RED, WHITE } from "../../config";


export const Content = styled.div`
  font-size: 14px;
`;

export const Table = styled.table<{ readOnly: boolean }>`
  text-align: center;
  border-collapse: collapse;

  th {
    background-color: ${BLACK};
    color: ${WHITE};
    padding: 6px 4px;
    font-size: 11px;
    border: 1px solid ${GRAY};
    min-width: 16px;

    &.rotate {
      position: relative;
      &:after {
        content: "CONSEQUENCE";
        transform: rotate(270deg);
        width: 18px;
        height: 28px;
        position: absolute;
        margin-top: 16px;
      }
    }
  }

  td {
    background-color: ${DINGY_GRAY};
    color: ${NEAR_WHITE};
    padding: 4px;
    font-size: 10px;
    width: 100px;
    height: 60px;
    border: 1px solid ${GRAY};
    transition: 0.1s ease;

    &.green,
    &.orange,
    &.red {
      padding: 0px;
      border: none;
      cursor: pointer;
      pointer-events: ${({ readOnly }) => (readOnly ? "none" : "unset")};
    }

    &.green {
      background-color: ${GREEN};
    }
    &.orange {
      background-color: ${ORANGE};
    }
    &.red {
      background-color: ${RED};
    }

    &.active-row,
    &.active-column {
      &:not(.green):not(.orange):not(.red) {
        background-color: ${LIGHT_GRAY};
      }
    }

    &.active-row {
      &.green,
      &.orange,
      &.red {
        position: relative;
        &:after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 4px);
          border-top: 2px dashed ${LIGHT_GRAY};
          border-bottom: 2px dashed ${LIGHT_GRAY};
        }
      }
    }

    &.active-column {
      &.green,
      &.orange,
      &.red {
        position: relative;
        &:after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: calc(100% - 4px);
          height: 100%;
          border-left: 2px dashed ${LIGHT_GRAY};
          border-right: 2px dashed ${LIGHT_GRAY};
        }
      }
    }

    &.active-cell {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        background-color: ${NEAR_WHITE};
        border: 2px dashed ${LIGHT_GRAY};
      }
    }
  }

  tr:nth-child(1),
  tr:nth-child(2),
  tr:nth-child(3) {
    td:first-child {
      background-color: unset;
      width: unset;
      height: unset;
      border: none;
    }
  }
`;

export const Captions = styled.div`
  margin-left: 5px;
  margin-top: 8px;
  > div {
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-top: 4px;
    .circle {
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-right: 4px;
      &.green {
        background-color: ${GREEN};
      }
      &.orange {
        background-color: ${ORANGE};
      }
      &.red {
        background-color: ${RED};
      }
    }
  }
`;
